import React, { useEffect } from "react";
import { BrowserRouter as Router, Redirect, Switch } from "react-router-dom";
import PublicRoute from "./Components/Routes/PublicRoute";
import PrivateRoute from "./Components/Routes/PrivateRoute";
import Home from "./Pages/Home";
import Forum from "./Pages/Forum";
import About from "./Pages/About";
import Profile from "./Pages/Profile";
import Login from "./Pages/Login";
import Terms from "./Pages/Terms";
import ForgotPassword from "./Pages/ForgotPassword";
import DoctorRegister from "./Pages/DoctorRegister";
import Admin from "./Pages/Admin";
import { MenuBarProvider } from "./Components/MenuBarProvider";
import { SnackbarAlertProvider } from "./Components/SnackbarAlert";
import { DialogProvider } from "./Components/DialogProvider";

import { ThemeProvider, createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  //Specify colors to be used
  palette: {
    primary: {
      main: "#03ceac",
      //light: "#61ffde",
      //dark: "#009c7d",
    },
    secondary: {
      main: "#3b5998",
      //light: "#6d85c9",
      light: "#0072bb",
      //dark: "#003069",
    },
    error: {
      main: "#f44336",
      //light: "#ff7961",
      //dark: "#ba000d",
    },
    warning: {
      main: "#ff9800",
      //light: "#ffc947",
      //dark: "#c66900",
    },
    info: {
      main: "#2196f3",
      //light: "#6ec6ff",
      //dark: "#0069c0",
    },
    success: {
      main: "#81c784",
      //light: "#b2fab4",
      //dark: "#519657",
    },
  },
});

const App = () => {
  /*
  const history = History;
  if (history.scrollRestoration) {
    history.scrollRestoration = "manual";
  }
  */
  useEffect(() => {
    if (typeof Storage !== "undefined") {
      if (localStorage.getItem("rememberUser")) {
        /*localStorage.removeItem("rememberUser");  clear localStorage credentials
        localStorage.removeItem("userID");
        localStorage.removeItem("userPassword");*/
        return;
      } else {
        localStorage.setItem("rememberUser", false);
        localStorage.setItem("userID", "");
        localStorage.setItem("userPassword", "");
        //console.log(localStorage.getItem("rememberUser"));
        //console.log(localStorage.getItem("userID"));
        //console.log(localStorage.getItem("userPassword"));
      }
    }
  }, []);
  return (
    <div>
      <ThemeProvider theme={theme}>
        <Router>
          <MenuBarProvider>
            <SnackbarAlertProvider>
              <DialogProvider>
                <Switch>
                  <PublicRoute
                    restricted={false}
                    component={Home}
                    path="/"
                    exact
                  />
                  <PublicRoute
                    restricted={false}
                    component={Forum}
                    path="/forum/:id"
                    sensitive
                  />
                  <PublicRoute
                    restricted={false}
                    component={About}
                    path="/about"
                    sensitive
                  />
                  <PrivateRoute
                    admin={false}
                    component={Profile}
                    path="/profile"
                    sensitive
                  />
                  <PublicRoute
                    restricted={true}
                    component={Login}
                    path="/login"
                    sensitive
                  />
                  <PublicRoute
                    restricted={false}
                    component={Terms}
                    path="/terms"
                    sensitive
                  />
                  <PublicRoute
                    restricted={true}
                    component={ForgotPassword}
                    path="/forgot_password"
                    sensitive
                  />
                  <PublicRoute
                    restricted={true}
                    component={DoctorRegister}
                    path="/doctor_register"
                    sensitive
                  />
                  <PrivateRoute admin={true} component={Admin} path="/admin" />
                  <Redirect to="/" />
                </Switch>
              </DialogProvider>
            </SnackbarAlertProvider>
          </MenuBarProvider>
        </Router>
      </ThemeProvider>
    </div>
  );
};

export default App;
